<template>
  <button
    type="button"
    class="close"
    aria-label="Close"
    @click="$modal.close(target)">
    <span aria-hidden="true">&times;</span>
  </button>
</template>

<script>
export default {
  name: 'ModalClose',

  props: {
    target: { required: true, type: String }
  }
}
</script>
